import { render, staticRenderFns } from "./ReadingRoom.vue?vue&type=template&id=db45f218&"
import script from "./ReadingRoom.vue?vue&type=script&lang=js&"
export * from "./ReadingRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports